import pageType from 'Addons/search/pageType.ts';
import { getPageType, getCollectionId, getPageId, getCustomerId } from './shopifyContext.ts';
import uiConfig from './uiConfig.js';

const currentPageType = getPageType();
const currentCollectionId = getCollectionId();
const currentPageId = getPageId();

const cultureCode = window.Shopify?.routes?.root.slice(0, -1) ?? '';

// 4: https://store.myshopify.com/en/collections/maintenance-tools/tag
// 3: https://store.myshopify.com/collections/maintenance-tools/tag
const referrerPosition = cultureCode ? 4 : 3;
const isReferrerInUrl =
  currentPageType === 'collection' &&
  window.location.pathname.split('/').filter(Boolean).length >= referrerPosition;

const urlQueryParam = new URLSearchParams(window.location.search).get('q');

const pageTypeToPreselectionMap = {
  category: currentCollectionId ? [{ field: 'collection_ids', term: `${currentCollectionId}` }] : [],
  brand: urlQueryParam ? [{ field: 'vendor', term: urlQueryParam }] : [],
};

function getLocalPreselection(pageType) {
  return pageTypeToPreselectionMap[pageType] || null;
}

function facetResponseHandler(response) {
  if (uiConfig.page.getPageType() === pageType.category && response.Facets && currentCollectionId) {
    const categoryFacet = response.Facets.find((facet) => facet.FieldName === 'category');

    if (categoryFacet) {
      const categoryPreselection = categoryFacet.Selection?.find(
        (facet) => facet.Payload === `${currentCollectionId}`,
      )?.Term;

      if (categoryPreselection) {
        categoryFacet.TreeLevel = categoryPreselection.split('>').length - 1;
      }
    }
  }

  return response;
}

function responseHandler(response) {
  return facetResponseHandler(response);
}

function collectExtra() {
  const { country, currency, locale } = window.Shopify;
  const { customerCompanyId, customerCompanyLocationId } = window.Convermax;

  const extra = {};

  if (country) {
    extra.country = country.toLowerCase();
  }

  const activeCurrency = currency?.active;
  if (activeCurrency) {
    extra.currency = activeCurrency.toLowerCase();
  }
  const currencyRate = currency?.rate;
  if (currencyRate) {
    extra.currencyRate = currencyRate;
  }

  if (locale) {
    extra.locale = locale;
  }

  if (cultureCode) {
    extra.culturecode = cultureCode;
  }

  if (currentPageType === 'page') {
    extra.pageId = currentPageId;
  }

  if (customerCompanyId) {
    extra.customerCompanyId = customerCompanyId;
  }
  if (customerCompanyLocationId) {
    extra.customerCompanyLocationId = customerCompanyLocationId;
  }

  return extra;
}

function getSearchRequestDefaults(pageType) {
  const requestDefaults = {};

  if (isReferrerInUrl) {
    requestDefaults.referrer = encodeURIComponent(window.location.pathname);
  }

  requestDefaults.extra = collectExtra();

  return requestDefaults;
}

function getAutocompleteRequestDefaults() {
  return collectExtra();
}

async function ajaxAddToCart(id, quantity = 1) {
  const formData = { items: [{ id, quantity }] };

  return fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });
}

async function addItemsToCart(ids) {
  for (const id of ids) {
    await ajaxAddToCart(id);
  }
}

getLocalPreselection.defaults = { getter: getLocalPreselection };

async function getCustomerAsync() {
  const id = getCustomerId();
  window.Convermax.customerId = id;
  window.Convermax.isLoggedIn = !!id;
  return id ? { id } : null;
}

export default {
  getLocalPreselection,
  getSearchRequestDefaults,
  responseHandler,
  facetResponseHandler,
  addItemsToCart,
  getAutocompleteRequestDefaults,
  getCustomerAsync,
  isReferrerInUrl,
  cultureCode,
};
